<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div v-if="!showView">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>
            <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
            <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="estabelecimentoSelecionado" />
            <TpDocSelect :ckAddTodos="true" v-model:idSelecionado="tpdocSelecionado" />
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closePage" />
        </div>

        
        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Data</th>
                <th>SIM</th>
                <th>Tipo</th>
                <th>Estabelecimento</th>
                <th>Validade</th>
                <th>Dias</th>
                <th>Situação</th>
            </tr></thead>

            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                    @click="openView(obj)"
                >
                    <td class="col-width-char10">{{ Funcoes.formatDateFromJson(obj.dtanexo) }}</td>
                    <td class="col-width-char30">{{ obj.nmsim }}</td>
                    <td class="col-width-char40">{{ obj.nmtpdoc }}</td>
                    <td>{{ obj.nmestabelecimento }}</td>
                    <td class="col-width-char10">{{ Funcoes.formatDateFromJson(obj.dtvalidade) }}</td>
                    <td class="col-width-char05 center">{{ Funcoes.formatInteger(obj.dias_prazo) }}</td>
                    <td class="col-width-char30">{{ obj.situacaonm }}</td>
                </tr>
            </tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="showView">
        <AnexoViewPage :idView="idView" @close="showView = false" />
    </div>
</template>


<script setup>
import { ref, onMounted } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import AnexoViewPage from '../visualizacoes/AnexoViewPage.vue';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';
import TpDocSelect from '@/components/selects/TpDocSelect.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const estabelecimentoSelecionado = ref(null);
const idSim = ref(null);
const idView = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const showView = ref(false);
const tpdocSelecionado = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closePage = () => {emit('close');}

const lerDados = async() => {
    const r = Validar.intervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
    if (!r.ok){msgAlerta.value = r.msg; return;}

    try{
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: idSim.value,
            idestabelecimento: estabelecimentoSelecionado.value,
            intparam1: 1,
            intparam2: tpdocSelecionado.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        const req = await Api.genericPost('/listas/anexos', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

function openView(obj){
    idView.value = obj.id;
    showView.value = true;
}

function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados)
</script>